export default __webpack_public_path__ + "static/media/go-to.b216c8ec.svg";